import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "@/shared/lib/utils";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // 配色走 token;cyber 的霓虹 checked 渐变/辉光由 skin-cyber.css `[role="checkbox"]` 规则还原
      //
      // ★圆角写死 4px,不跟 --radius 走:tailwind 的 rounded-sm = calc(var(--radius) - 4px),
      // 而 index.css 把 --radius 调到 0.75rem(12px) 之后 rounded-sm 算出来是 8px ——
      // 8px 正好是 16×16 的一半,勾选框渲染成**正圆**,跟 radio 一模一样。用户因此问过
      // 「产品那里是否应该多选」:它本来就是多选,只是控件的形状在说单选。
      // 方=多选、圆=单选这条约定得靠形状立住,别再让它跟着圆角 token 漂。
      "peer h-4 w-4 shrink-0 rounded-[4px] transition-all duration-200",
      "border border-input bg-background",
      "data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=checked]:text-primary-foreground",
      "hover:border-ring",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
